import moment from 'moment'

function mapDateFormat(format) {
    const formats = {
        'd-M-Y': 'DD-MMM-YYYY',
        'M-d-Y': 'MMM-DD-YYYY',
        'Y-M-d': 'YYYY-MMM-DD',
        'd-M': 'DD-MMM'
    }
    return formats[format]
}

function mapTimeFormat(militaryTime) {
    const formats = {
        12: 'hh:mm A',
        24: 'HH:mm'
    }
    return formats[militaryTime]
}

function formatDate(strDate, strFormat) {
    if (typeof (strDate) === 'undefined' || strDate === '' || strDate === null) {
        return ''
    }

    return moment(strDate).format(mapDateFormat(strFormat))
}

function formatDateTime(strDateTime, strFormat, militaryTime) {
    if (typeof (strDateTime) === 'undefined' || strDateTime === '' || strDateTime === null) {
        return ''
    }

    return moment(strDateTime).format(`${mapDateFormat(strFormat)} ${mapTimeFormat(militaryTime)}`)
}

function debounce(fn, delay) {
    let timeoutId = null
    return function () {
        clearTimeout(timeoutId)
        let args = arguments
        let thisContext = this
        timeoutId = setTimeout(function () {
            fn.apply(thisContext, args)
        }, delay)
    }
}

function formatFileSize(size) {
    if (isNaN(parseFloat(size))) {
        return '-'
    }
    let i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024))
    let number = (size / Math.pow(1024, i)).toFixed(2) * 1
    if (number > 1000 && number < 1024) {
        number = number / 1000
        i++
    }
    return new Intl.NumberFormat('en').format(number) + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
}

function getCookie(id) {

    let value = document.cookie.match('(^|;)?' + id + '=([^;]*)(;|$)')
    return value ? decodeURI(value[2]) : null

}

export {mapDateFormat, mapTimeFormat, formatDate, formatDateTime, debounce, formatFileSize, getCookie}
